module.exports = __webpack_public_path__ + "img/title+@3x.d194cce0.png";